import React from 'react';
import ReactDOM from 'react-dom';
import './bootstrap.css';
import './index.css';
import './grid.css';
import './navbar.css';
import Framework from './framework';
import * as serviceWorker from './serviceWorker';
import 'react-modal-video/scss/modal-video.scss';

ReactDOM.render(<Framework />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
